import { render, staticRenderFns } from "./AnnouncementsItem.vue?vue&type=template&id=08eaa875&scoped=true&"
import script from "./AnnouncementsItem.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementsItem.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementsItem.vue?vue&type=style&index=0&id=08eaa875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eaa875",
  null
  
)

export default component.exports